import { Modal } from "antd";
import { FailIcon, readyIcon } from "@/config/config";
import useLanguage from "@/hooks/useLanguage";

const EligibleModal = ({ onCancel, show }) => {
  const { t } = useLanguage();

  return <Modal title={null} centered footer={null} width={530} visible={show} onCancel={(e) => {
    e.stopPropagation();
    onCancel();
  }}>
    <div className={"flex flex-col items-center mt-5"}>
      <img src={readyIcon} className={"w-[58px] h-[58px] object-cover mb-4"} />
      <div className={"flex flex-col"}>
        <div className={"flex"}>
          <div className={"h-[21px] flex flex-col justify-center mr-2"}>
            <div className={"w-1 h-1  rounded-full bg-[#222] shrink-0"}></div>
          </div>
          <div className={"text_222 text-[14px] leading-[21px] break-words"}>
            {t('eligibleModal.ready_to_join')}
            <span className={"high_light mx-1 font-bold"}>{t('eligibleModal.highest_commissions')}</span>
            {t('eligibleModal.commission_range')}
            <span className={"high_light mx-1 font-bold"}>{t('eligibleModal.exclusive_bonuses')}</span>
            {t('eligibleModal.personalized')}
            <span className={"high_light mx-1 font-bold"}>{t('eligibleModal.one_on_one_support')}</span>
            {t('eligibleModal.more_benefits')}
          </div>
        </div>

        <div className={"flex"}>
          <div className={"h-[21px] flex flex-col justify-center mr-2"}>
            <div className={"w-1 h-1  rounded-full bg-[#222] shrink-0"}></div>
          </div>
          <div className={"text_222 text-[14px] leading-[21px]"}>
            {t('eligibleModal.partner_link_info')}
            <span className={"high_light mx-1 font-bold"}>{t('eligibleModal.partner_link')}</span>
            {t('eligibleModal.to_tiktok')}
            <span className={"high_light mx-1 font-bold"}>{t('eligibleModal.accept_request')}</span>
            {t('eligibleModal.exclamation')}
          </div>
        </div>
        <div className={"flex"}>
          <div className={"h-[21px] flex flex-col justify-center mr-2"}>
            <div className={"w-1 h-1  rounded-full bg-[#222] shrink-0"}></div>
          </div>
          {t('eligibleModal.welcome')}
        </div>
      </div>
      <div onClick={onCancel} className={"h-[33px] hover:opacity-80 transition-all ease-in w-[200px] flex items-center justify-center cursor-pointer bg-linear text-white text-[14px] font-bold rounded mt-5"}>{t('eligibleModal.get_it')}</div>
    </div>
  </Modal>;
};


export const Eligible7DTipsModal = ({ onCancel, show, content }) => {
  const { t } = useLanguage();

  return <Modal className={"zoom_1920"} title={null} centered footer={null} width={360} visible={show} onCancel={(e) => {
    e.stopPropagation();
    onCancel();
  }}>
    <div className={"flex flex-col items-center mt-5"}>
      <img src={FailIcon} className={"w-[58px] h-[58px] object-cover mb-4"} />
      <div className={"text_222 text-center text-[14px] leading-[21px]"}>
        {content}
      </div>
    </div>
  </Modal>;
};

export default EligibleModal;
